// Roles unificados de VLS: field_rep -> editor, manager -> admin.
// Se normaliza en un solo punto (AuthContext) y el resto de la app solo conoce
// los nombres nuevos. Los viejos siguen valiendo durante la transición.
export function normalizarRolVisitas(rol) {
  if (rol === 'field_rep') return 'editor';
  if (rol === 'manager') return 'admin';
  return rol ?? null;
}
